import { Warning } from "@mui/icons-material";
import {
  Dialog,
  DialogTitle,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { FormButtonGroup } from "../../../../components/form";
import { MobileBottomSheet } from "../../../../components/common/MobileBottomSheet";

interface IProps {
  isOpen: boolean;
  handleClose: () => void;
  onClick: () => void;
}

export function InactivateAccount({ isOpen, handleClose, onClick }: IProps) {
  const theme = useTheme();
  const isMobileLayout = useMediaQuery(theme.breakpoints.down("md"));

  const footer = (
    <FormButtonGroup
      onGoBackButtonClick={handleClose}
      onNextButtonClick={onClick}
      goBackButtonText="Cancelar"
      nextButtonText="Confirmar"
    />
  );

  const body = (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={1}
      sx={{ px: 2, pt: 1, pb: isMobileLayout ? 0 : 2 }}
    >
      <Warning fontSize="medium" sx={{ color: "warning500.main" }} />
      <DialogTitle align="center" sx={{ p: 0, flex: 1 }}>
        Deseja confirmar o cancelamento da sua conta?
      </DialogTitle>
    </Stack>
  );

  if (isMobileLayout) {
    return (
      <MobileBottomSheet
        open={isOpen}
        onClose={handleClose}
        title="Cancelar conta"
        disableBackdropClose
        size="auto"
        footer={footer}
      >
        {body}
      </MobileBottomSheet>
    );
  }

  return (
    <Dialog
      PaperProps={{
        sx: {
          borderRadius: "10px",
          padding: 2,
          paddingX: { xs: 1, sm: 4, md: 8 },
          maxWidth: "1200px",
        },
      }}
      maxWidth="sm"
      onClose={handleClose}
      open={isOpen}
    >
      {body}
      {footer}
    </Dialog>
  );
}
